import { Container, Link, Stack, Text } from "basis";
import { FC } from "react";
import { CreditCard } from "../CreditCard/CreditCard";
import { SvgInline } from "../SvgInline/SvgInline";
import { State } from "./types";

interface Props {
  state: State;
}

export const Success: FC<Props> = ({ state: { accountInfo } }) => (
  <Stack gap="8">
    <Container bg="grey.t05" padding="4">
      {accountInfo && (
        <CreditCard
          cardName={accountInfo.cardName}
          cardEndsWith={accountInfo.cardEndsWith}
        />
      )}
    </Container>
    <SvgInline name="icon-celebrate" size="120" />
    <Container>
      <Text as="h4" textStyle="heading5" textStyle-sm="heading4">
        Credit limit has been reduced successfully
      </Text>
      <Text margin="4 0 0 0">
        Your new credit limit has been applied to your account and is in effect
        immediately.
      </Text>
    </Container>
    <Link appearance="primary-button" width="180" href="/" newTab={false}>
      Go to overview
    </Link>
  </Stack>
);
